import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setToken } from '@/lib/api';
import { useAuth } from '@/lib/auth';

export function LoginCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();

  useEffect(() => {
    // El token viene en URL fragment (#token=...) para que NUNCA llegue al server
    const hash = window.location.hash.replace(/^#/, '');
    const params = new URLSearchParams(hash);
    const token = params.get('token');

    if (token) {
      setToken(token);
      // Limpiar el hash de la URL
      window.history.replaceState({}, '', '/');
      void refresh().then(() => navigate('/', { replace: true }));
    } else {
      navigate('/login?error=Sin%20token', { replace: true });
    }
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center text-ink-400">
      Validando sesión...
    </div>
  );
}
